import { render, staticRenderFns } from "./bookmarkCard.vue?vue&type=template&id=1c00e744&scoped=true&"
import script from "./bookmarkCard.vue?vue&type=script&lang=ts&"
export * from "./bookmarkCard.vue?vue&type=script&lang=ts&"
import style0 from "./bookmarkCard.vue?vue&type=style&index=0&id=1c00e744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c00e744",
  null
  
)

export default component.exports